import { render, staticRenderFns } from "./FormSetTimeZone.vue?vue&type=template&id=d2520268"
import script from "./FormSetTimeZone.vue?vue&type=script&lang=js"
export * from "./FormSetTimeZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports